import { isAxiosError } from 'axios';

export const getErrorMessage = (error: unknown) => {
  let message = '';

  if (isAxiosError(error)) {
    message = Array.isArray(error.response?.data?.message)
      ? error.response?.data?.message.join(<br />)
      : error.response?.data?.message || error.message;
  } else if (error instanceof Error) {
    message = error.message;
  } else {
    message = 'Something went wrong';
  }

  return message;
};
